import * as React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';

import FlexContainer from 'global_elements/Layouts/FlexContainer';
import InlineText from 'global_elements/Text/InlineText';
import { ReactComponent as SortIcon } from 'icons/mho-sort-icon-white.svg';
import Button from 'global_elements/Button';
import { ButtonVariant } from 'global_elements/Button/variants';

import { CMPatientCompletionDataRow, CMPatientCompletionTableProps } from 'types/tableProps';
import { AlignVariant, DisplayVariant, JustifyVariant } from 'global_elements/Layouts/FlexContainer/variants';
import { FontColors, FontSizes } from 'global_elements/Text/variants';
import Utilities from 'api/lib/Utilities';
import { EventTypes } from 'constants/events';

import { AlternatingBasicTableStyle } from '../styles';

const NoDataComponent: React.JSX.Element = <InlineText text="No Data Found." fontColor={FontColors.PRIMARY} fontSize={FontSizes.LARGE} />;

const columns = (
  onChangeAccessType: (row: CMPatientCompletionDataRow) => any,
  openEventsList: (row: CMPatientCompletionDataRow, eventType: number) => any,
  hideEvents: boolean,
): TableColumn<CMPatientCompletionDataRow>[] => {
  const cols: TableColumn<CMPatientCompletionDataRow>[] = [
    {
      name: 'Month',
      selector: (row) => row.month,
      sortable: true,
    },
    {
      name: <div>Complete Samples</div>,
      selector: (row) => row.complete,
      sortable: true,
    },
    {
      name: <div>Total Samples</div>,
      selector: (row) => row.total,
      sortable: true,
    },
    {
      name: <div>Sample Completion %</div>,
      selector: (row) => row.completionPercent,
      sortable: true,
      cell: (row) => (
        <div>
          {/* eslint-disable-next-line no-nested-ternary */}
          {row.completionPercent && parseFloat(row.completionPercent) < 100 ? (
            <span>
              <Button extraClasses="completion-grid-button completion-grid-warning" variant={ButtonVariant.INVISIBLE} onClick={() => onChangeAccessType(row)}>
                {`${Utilities.roundToTwoDecimal(parseFloat(row.completionPercent))}%`}
              </Button>
            </span>
          ) : row.completionPercent && parseFloat(row.completionPercent) >= 100 ? (
            <span>{`${Utilities.roundToTwoDecimal(parseFloat(row.completionPercent))}%`}</span>
          ) : (
            <span>{row.completionPercent}</span>
          )}
        </div>
      ),
    },
    {
      name: <div>Leave Days Completion</div>,
      selector: (row) => row.leaveDays,
      sortable: true,
    },
    {
      name: <div>Reported Restraints</div>,
      selector: (row) => row.restraintsCnt,
      sortable: true,
      omit: hideEvents,
      cell: (row) => (
        <div>
          <span>
            <Button
              extraClasses={`${'completion-grid-button'}${row.restraintsCnt === '0' ? ' completion-grid-warning' : ''} `}
              variant={ButtonVariant.INVISIBLE}
              onClick={() => openEventsList(row, EventTypes.RESTRAINT)}
            >
              {row.restraintsCnt}
            </Button>
          </span>
        </div>
      ),
    },
    {
      name: <div>Reported Seclusions</div>,
      selector: (row) => row.seclusionsCnt,
      sortable: true,
      omit: hideEvents,
      cell: (row) => (
        <div>
          <span>
            <Button
              extraClasses={`${'completion-grid-button'}${row.seclusionsCnt === '0' ? ' completion-grid-warning' : ''} `}
              variant={ButtonVariant.INVISIBLE}
              onClick={() => openEventsList(row, EventTypes.SECLUSION)}
            >
              {row.seclusionsCnt}
            </Button>
          </span>
        </div>
      ),
    },
  ];

  return cols;
};

const CMPatientCompletionTable = (props: CMPatientCompletionTableProps): React.JSX.Element => (
  <FlexContainer display={DisplayVariant.FLEX_COL} justify={JustifyVariant.CENTER} align={AlignVariant.END} extraClasses="patient-completion-table">
    <DataTable
      dense
      persistTableHead
      sortIcon={<SortIcon />}
      customStyles={AlternatingBasicTableStyle}
      columns={columns(props.openIncompletePatients, props.openEventsList, props.hideEvents)}
      data={props.data}
      noDataComponent={NoDataComponent}
    />
  </FlexContainer>
);

export default CMPatientCompletionTable;
